function getSubmitButtons(form) {
  return Array.prototype.slice.call(
    form.querySelectorAll('button[type="submit"], input[type="submit"], input.wpcf7-submit')
  );
}

function setSubmitButtonsDisabled(form, isDisabled) {
  getSubmitButtons(form).forEach(function (button) {
    button.disabled = isDisabled;
    button.classList.toggle("is-disabled", isDisabled);
  });
}

function setSpinnerVisible(form, isVisible) {
  Array.prototype.slice.call(form.querySelectorAll(".wpcf7-spinner")).forEach(function (spinner) {
    spinner.classList.toggle("is-visible", isVisible);
  });
}

export function initContactForm7SubmitLock() {
  document.addEventListener("submit", function (event) {
    var form = event.target;

    if (!form || !form.classList || !form.classList.contains("wpcf7-form")) {
      return;
    }

    setSubmitButtonsDisabled(form, true);
    setSpinnerVisible(form, true);
  }, true);

  document.addEventListener("wpcf7submit", function (event) {
    if (!event.target) {
      return;
    }

    setSubmitButtonsDisabled(event.target, false);
    setSpinnerVisible(event.target, false);
  });
}
